import React from "react";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import { CardForm } from "../../ui/templates/card";
import moment from "moment";
import { Box } from "@material-ui/core";
import { fontStyleBlackHeading, fontStyleHeading } from "../../ui/constants";

export default ({
  joinedUpcoming,
  otherUpcoming,
  past,
  events,
  onRedirectToTeamByID,
  onRedirectToEventByID,
  isLoading,
  handleCloseModal,
}) => {
  const nonActiveTabStyle = {
    color: "#E00000",
  };

  return (
    <Box>
      {events && (
        <Box pl={2} pr={2}>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <Tabs
                className="customTabs"
                defaultActiveKey="upcoming_events"
                id="uncontrolled-tab-example"
              >
                <Tab eventKey="upcoming_events" title="Upcoming Events">
                  {joinedUpcoming.length > 0 && (
                    <Box>
                      <Box style={fontStyleBlackHeading} pb={1}>
                        Joined <span style={fontStyleHeading}>Events</span>
                      </Box>
                      {joinedUpcoming.map((i, k) => {
                        return (
                          <CardForm
                            joined={true}
                            joined_button_text="Event details"
                            key={k}
                            id={i.id}
                            image={i.eventLogo}
                            title={i.title}
                            date={
                              moment(i.startDate).format("DD/MM/YYYY") +
                              "-" +
                              moment(i.endDate).format("DD/MM/YYYY")
                            }
                            address={i.address}
                            description={i.description}
                            button_text="Show the Team"
                            style_button="lg-button"
                            onClick={() => {
                              onRedirectToTeamByID(
                                i?.teams[0]?.id,
                                i?.teams[0]?.id
                              );
                            }}
                            onJoinedClick={() => {
                              onRedirectToEventByID(i.id, "Event details");
                            }}
                          />
                        );
                      })}
                    </Box>
                  )}

                  {otherUpcoming.length > 0 && (
                    <Box>
                      <Box style={fontStyleBlackHeading} pb={1}>
                        Not Joined <span style={fontStyleHeading}>Events</span>
                      </Box>
                      {otherUpcoming.map((i, k) => {
                        return (
                          <Box mb={2}>
                            <CardForm
                              key={k}
                              id={i.id}
                              image={i.eventLogo}
                              title={i.title}
                              date={
                                moment(i.startDate).format("DD/MM/YYYY") +
                                "-" +
                                moment(i.endDate).format("DD/MM/YYYY")
                              }
                              address={i.address}
                              description={i.description}
                              button_text="Join Event"
                              style_button="lg-button"
                              onClick={() => onRedirectToEventByID(i.id)}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Tab>
                <Tab eventKey="past_events" title="Past Events">
                  {past.length > 0 && (
                    <Box>
                      <Box style={fontStyleBlackHeading} pb={1}>
                        Past <span style={fontStyleHeading}>Events</span>
                      </Box>
                      {past.map((i, k) => {
                        return (
                          <Box mb={2}>
                            <CardForm
                              key={k}
                              id={i.id}
                              image={i.eventLogo}
                              title={i.title}
                              date={
                                moment(i.startDate).format("DD/MM/YYYY") +
                                "-" +
                                moment(i.endDate).format("DD/MM/YYYY")
                              }
                              address={i.address}
                              description={i.description}
                              button_text="Show Event"
                              style_button="lg-button"
                              onClick={() => onRedirectToEventByID(i.id)}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Box>
      )}
      <style>
        {`
          .nav-link:not(.active) {
            color: ${nonActiveTabStyle.color} !important;
            border: none !important;
          }

          .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
            border-bottom-color: transparent !important;
          }

          .nav-tabs .nav-link {
            position: relative;
          }

          .nav-tabs .nav-link::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px; 
            background-color: #E00000; 
            transform: scaleX(0); 
            transition: transform 0.3s ease; 
          }

          .nav-tabs .nav-link.active::after {
            transform: scaleX(1);
          }
          @media only screen and (max-width: 768px) {
            .nav-tabs {
              flex-direction: column;
            }
          }
        `}
      </style>
    </Box>
  );
};
